<template>
  <div v-show="visible">
    <div class="mask"></div>
    <div class="pwc-start">
      <div class="bg-content"></div>
      <div class="pwc-dialog-content">
        <p class="title">温馨提示</p>
        <div class="content-body">
          <div v-if="tipTag===timeTip"
               class="tip">
            <p>考试时间：{{examTime}}！</p>
            <p>请在规定时间内作答哟~</p>
          </div>
          <div v-else-if="tipTag===countTip"
               class="tip tip1">
            本考试只可作答{{examNum}}次哟~
          </div>
          <div v-else-if="tipTag===noCountTip"
               class="tip tip1">
            您已经超过作答次数！
          </div>
          <div class="option">
            <a v-if="tipTag===countTip"
               href="javascript:void(0)"
               class="look-score"
               @click="closeDialog">取消</a>
            <a v-if="tipTag===timeTip || tipTag===noCountTip"
               href="javascript:void(0)"
               class="closeReal"
               @click="closeDialog">关闭</a>
            <a v-if="tipTag===countTip"
               href="javascript:void(0)"
               class="close"
               @click="viewResults">继续做题</a>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import { formatTime } from '@/utils'
export default {
  name: 'pwcExamStart',
  props: {
    visible: { type: Boolean },
    isNext: { type: Boolean, default: false },
    tipInfo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      tipTag: '', // 时间提醒timeTip 考试次数提醒countTip 超过作答次数提醒noCountTip
      examTime: '', // 考试时间
      examNum: 0,
      timeTip: 'TIMETIP',
      countTip: 'COUNTTIP',
      noCountTip: 'NOCOUNTTIP',
    }
  },
  watch: {
    tipInfo() {
      this.init()
    },
  },
  mounted() {
    const { siteCourseID, courseID } = this.$route.query
    this.courseID = Number(courseID)
    this.siteCourseID = Number(siteCourseID)
    if (this.tipInfo) {
      this.init()
    }
  },
  methods: {
    init() {
      // 考试时间取后台配置的开始开始、结束时间
      const res = this.tipInfo
      // 是否在考试时间  0-未在考试时间   1-在考试时间
      if (res.isExamDate === 0) {
        this.tipVisible = true
        this.tipTag = this.timeTip
        this.examTime =
          (res.startTime
            ? formatTime(res.startTime, '{y}.{m}.{d} {h}:{i}:{s}')
            : res.startTime) +
          ' - ' +
          (res.endTime
            ? formatTime(res.endTime, '{y}.{m}.{d} {h}:{i}:{s}')
            : res.endTime)
      } else if (res.isExamDate === 1) {
        // 是否超过做题次数  0-超过做题次数  1-未超过做题时间
        if (res.num != -1) {
          // 步骤页已判断
          this.tipTag = this.countTip
          this.examNum = res.num || 0
          // if (res.isExceedNum === 0) {
          //   this.tipTag = this.noCountTip
          // } else if (res.isExceedNum === 1) {
          // }
        } else {
          this.$emit('update:visible', false)
          this.$emit('update:isNext', true)
        }
      }
    },
    closeDialog() {
      // 关闭当前页
      // window.location.href = 'about:blank'
      // window.close()
      // 点击关闭，跳转课程列表页
      window.location.href = '//member.chinaacc.com/homes/mycourse'
    },
    viewResults() {
      // 点击, 判断是否超过答题次数
      // 若超过, 弹窗3
      // 若未超过，弹窗关闭
      if (this.tipInfo.isExceedNum === 0) {
        this.tipTag = this.noCountTip
      } else if (this.tipInfo.isExceedNum === 1 && this.examNum > 0) {
        this.$emit('update:visible', false)
        this.$emit('update:isNext', true)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
$imgUrl: '~@/assets/images/doExam/';
.pwc-dialog-content {
  position: absolute;
  width: 400px;
  left: 0;
  right: 0;
  margin: auto;
  top: 180px;
  padding-bottom: 10px;
  background: url($imgUrl + 'bottom.gif') bottom center no-repeat;
  z-index: 999;

  .title {
    width: 400px;
    height: 33px;
    background: url($imgUrl + 'titleOther.gif') no-repeat;
    text-indent: 20px;
    line-height: 33px;
    font-size: 16px;
    font-weight: bold;
    color: #0b3b8c;
  }

  .content-body {
    width: 400px;
    overflow: hidden;
    background: url($imgUrl + 'bg.gif') repeat-y;

    .tip {
      height: 60px;
      width: auto;
      margin: 30px auto 10px auto;
      font-size: 14px;
      text-align: center;
      > p {
        line-height: 30px;
      }
    }
    .tip1 {
      line-height: 50px;
    }

    .option {
      height: 70px;
      padding: 0 50px 30px;
      text-align: center;

      a {
        display: block;
        float: left;
        width: 140px;
        height: 38px;
        text-align: center;
        font-size: 14px;
        color: #2773b3;
        line-height: 38px;
        background: url($imgUrl + 'an3Other.gif') no-repeat;
        cursor: pointer;

        &:hover {
          color: #ff0000;
        }
      }

      .close {
        float: right;
      }

      .closeReal {
        margin-left: 25%;
      }
    }

    .optionTen a {
      float: none !important;
      margin: 40px 0 0 82px;
    }
  }
}
</style>